import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'flatpickr/dist/themes/material_blue.css'; // or your theme
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { useNavigate, useParams } from 'react-router-dom';
import { globalErrorHandler } from '../../../utils/GlobalErrorHandler'
import Select from 'react-select';
import { formatUSPhone } from '../../helpers/common.jsx';





const GuestIntakeForm = () => {

  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const [loading, setLoading] = useState(false);
  const [guest, setGuest] = useState(null);
  const [states, setStates] = useState([]);
  const [previousGuestList, setPreviousGuestList] = useState([]);
  const [selectedGuest, setSelectedGuest] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPaid, setIsPaid] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  // Load data on mount
  useEffect(() => {

    getStates();
    getPreviousfGuests();

    if (isEdit) {
      getGuest();
    }
    else {
      const saved = localStorage.getItem('guest-form');
      if (saved)
        setGuest(JSON.parse(saved));
      else
        setGuest({ today: formatDate(new Date()), dob: null });
    }

  }, [id]);


  // Save data on every change
  useEffect(() => {

    if (guest && Object.keys(guest).length > 0) {
      localStorage.setItem("guest-form", JSON.stringify(guest));
    }

  }, [guest]);



  const getPreviousfGuests = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-previous-guests-users`, {
        params: {},
        withCredentials: true
      });

      if (res.data.status) {
        const users = res.data?.users || [];
        const user_options = users.map(u => ({
          value: u.id,
          label: `${u.name} ${u.email}`,
          name:u.name,
          dob:u.dob,
          gender:u.gender,
          ssn:u.ssn,
          email:u.email,
          phone:u.phone,
        }));
        setPreviousGuestList(user_options);
      } else {
        setPreviousGuestList([]);
      }
    } catch (error) {
      globalErrorHandler(error, navigate);
    } finally {
      setIsLoading(false);
    }
  };

  const getGuest = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/get-guest/${id}`,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const g = response.data?.guest;

    // Map flat DB fields → structured checklist
    const checklist = {
      doc_ss_card: {
        checked: g.doc_ss_card === 1,
        note: g.doc_ss_card_plan || ""
      },
      doc_birth_cert: {
        checked: g.doc_birth_cert === 1,
        note: g.doc_birth_cert_plan || ""
      },
      doc_photo_id: {
        checked: g.doc_photo_id === 1,
        note: g.doc_photo_id_plan || ""
      },
      doc_driver_license: {
        checked: g.doc_license === 1,
        note: g.doc_license_plan || ""
      },
      doc_assistance: {
        checked: g.doc_assistance === 1,
        note: g.doc_assistance_plan || ""
      },
    };

  setGuest({
      ...g,
      documentChecklist: checklist
    });
          setIsPaid(( g?.stripe_subscription_id || g.stripe_payment_method_id ));

    } catch (error) {
      globalErrorHandler(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  const getStates = async () => {
    //  setIsLoading(true);
    try {
      const response = await axios.get(process.env.REACT_APP_WEB_SERVICES_URL + "/get-states", {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });
      if (response?.data?.status) {
        setStates(response.data.states || []);
      } else {
        Swal.fire({ icon: "error", title: "Error", text: "No States Record Found" });
      }
    } catch (error) {
      globalErrorHandler(error, navigate);
    }

  };

  const formatDate = (date) => {
    if (!date) return "";
    return date.toISOString().split("T")[0];
  };

  const validate = () => {
    const errs = {};

    if (!guest?.name?.trim()) errs.name = "Full Name is required.";
    if (!guest?.dob) errs.dob = "Date of Birth is required.";
    if (!guest?.email) errs.email = "Email is required.";


    if (Object.keys(errs).length > 0) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        html: Object.values(errs).join("<br>"), // join messages with line breaks
      });
      return false;
    }

    return true;
  };

  const handleSaveAndNext = async () => {
    try {
      setIsDisabled(true);

      const checklist = guest.documentChecklist || {};
    const payload = {
      ...guest,
      doc_ss_card: checklist.doc_ss_card?.checked ? 1 : 0,
      doc_ss_card_plan: checklist.doc_ss_card?.note || "",
      doc_birth_cert: checklist.doc_birth_cert?.checked ? 1 : 0,
      doc_birth_cert_plan: checklist.doc_birth_cert?.note || "",
      doc_photo_id: checklist.doc_photo_id?.checked ? 1 : 0,
      doc_photo_id_plan: checklist.doc_photo_id?.note || "",
      doc_license: checklist.doc_driver_license?.checked ? 1 : 0,
      doc_license_plan: checklist.doc_driver_license?.note || "",
      doc_assistance: checklist.doc_assistance?.checked ? 1 : 0,
      doc_assistance_plan: checklist.doc_assistance?.note || "",
    };
      let response;
      if (!validate()) return;

      if (isEdit) {
        response = await axios.put(
          `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/update-guest`,
          payload,
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
      } else {
        response = await axios.post(
          `${process.env.REACT_APP_WEB_SERVICES_URL}/overseer/save-guest`,
          payload,
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
      }

      if (response.data.status) {
        localStorage.removeItem("guest-form");
        const guestId = isEdit ? id : response.data.guest_id;
        navigate(`/overseer/guest-management/guest-intake-form-move-in/${guestId}`);
      } else {
        Swal.fire("Error", "Something went wrong.", "error");
      }
            setIsDisabled(false);

    } catch (error) {
            setIsDisabled(false);
      globalErrorHandler(error, navigate);
    }
  };

   const setGuestUser = async (g) => {

     setGuest({ ...guest, 
          name:g.name,
          gender:g.gender,
          ssn:g.ssn,
          email:g.email,
          phone:g.phone,
          user_id:g.value,
          dob:g.dob,
          
    })

   }


  const handleCancelAndDiscard = async () => {


    Swal.fire({
      title: 'Are you sure?',
      text: 'This will discard all unsaved data.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, discard it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {

        localStorage.removeItem('guest-form');
        setGuest({ today: formatDate(new Date()), });

        Swal.fire('Discarded!', 'All unsaved data has been removed..', 'status');

      }
      //window.scrollTo({ top: 0, behavior: 'smooth' });
    });


  }
  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">isLoading...</span>
        </div>
      </div>
    );
  }




  return (
    <div className="container-fluid px-4 mt-4 mb-5  " id="guest-main">

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">{isEdit ? `Editing Guest Intake Form: ${id}` : 'Guest Intake Form'} </h3>
      </div>

      <div className="row mb-4" >
        <div className="col-lg-4 d-flex flex-row align-items-center fw-bold"><div className="icon-circle me-2"><i className="bi bi-briefcase-fill"></i></div>Details</div>
        <div className="col-lg-4 d-flex flex-row align-items-center fw-bold text-secondary"><div className="icon-circle me-2"><i className="bi bi-person-fill"></i></div>Move-In</div>
        <div className="col-lg-4 d-flex flex-row align-items-center fw-bold text-secondary"><div className="icon-circle me-2"><i className="bi bi-file-earmark-check-fill"></i></div>Review</div>
      </div>


      <div className="card shadow">
        <div className="card-header"><h5 className="mb-0">Basic Information</h5></div>
        <div className="card-body p-4">

{!isEdit && 
          <div className="row g-4">


            <div className="col-md-6 col-sm-12">

              <Select options={[{ label: "Select Previous Guest...", value: "" }, ...previousGuestList]}  value={selectedGuest}  onChange={(g) => {setSelectedGuest(g);setGuestUser(g);}} placeholder="Select Previous Guest..."  isSearchable   />

            </div>

             <div className="col-12">
                  <hr/>
             </div>
          </div>
          }
          <div className="row g-4 mt-2">
            {/* Full Name */}
            <div className="col-md-6">
              <label className="form-label">Full Name <span className="text-danger">*</span></label>
              <input type="text" className="form-control" placeholder="Enter full name"
                value={guest?.name || ""} onChange={(e) => setGuest({ ...guest, name: e.target.value })} />
            </div>


            {/* Date of Birth */}
            <div className="col-md-6">
              <label className="form-label">Date of Birth <span className="text-danger">*</span></label>

              <Flatpickr placeholder="Select a date" className="form-control" value={guest?.dob || ""} onChange={(date) => setGuest({ ...guest, dob: formatDate(date[0]) })} options={{ altInput: true, altFormat: "m/d/Y", dateFormat: "Y-m-d", maxDate: "today" }} />


            </div>



            {/* Gender */}
            <div className="col-md-6">
              <label className="form-label">Gender</label>
              <select className="form-select" value={guest?.gender || ""} onChange={(e) => setGuest({ ...guest, gender: e.target.value })}   >
                <option value="">Select gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* Social Security Number */}
            <div className="col-md-6">
              <label className="form-label">Social Security Number</label>
              <input type="text" className="form-control" placeholder="XXX-XX-XXXX" value={guest?.ssn || ""} onChange={(e) => setGuest({ ...guest, ssn: e.target.value })}
              />
            </div>

            {/* Email ID */}
            <div className="col-md-6">
              <label className="form-label">Email ID<span className="text-danger">*</span></label>
              <input type="email" className="form-control" placeholder="example@email.com" value={guest?.email || ""} onChange={(e) => setGuest({ ...guest, email: e.target.value })} />
            </div>

            {/* Phone Number */}
            <div className="col-md-6">
              <label className="form-label">Phone Number</label>
              <input type="tel" className="form-control" placeholder="123-456-7890" maxLength={14} value={guest?.phone || ""}  onChange={(e) => setGuest({ ...guest, phone: formatUSPhone(e.target.value) })}  />
            </div>
          </div>


        </div>
      </div>



      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Probation/Parole Information</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            <div className="col-md-6">
              <label className="form-label">Officer Name</label>
              <input type="text" className="form-control" placeholder="Enter officer's full name" value={guest?.officer_name || ''} onChange={(e) => setGuest({ ...guest, officer_name: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Officer Phone</label>
              <input type="tel" className="form-control" placeholder="123-456-7890" maxLength={14} value={guest?.officer_phone || ''} onChange={(e) => setGuest({ ...guest, officer_phone: formatUSPhone(e.target.value) })} />
            </div>
          </div>
        </div>
      </div>






      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Demographics</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            <div className="col-md-6">
              <label className="form-label">Ethnicity</label>
              <select className="form-select" value={guest?.ethnicity || ''} onChange={(e) => setGuest({ ...guest, ethnicity: e.target.value })}>
                <option value="">Select ethnicity</option>
                <option value="Hispanic or Latino">Hispanic or Latino</option>
                <option value="Not Hispanic or Latino">Not Hispanic or Latino</option>
              </select>
            </div>
            <div className="col-md-6">
              <label className="form-label">Education Level</label>
              <select className="form-select" value={guest?.education_level || ''} onChange={(e) => setGuest({ ...guest, education_level: e.target.value })}>
                <option value="">Select education level</option>
                <option value="Less than high school">Less than high school</option>
                <option value="High school diploma or equivalent (e.g., GED)">High school diploma or equivalent (e.g., GED)</option>
                <option value="Some college, no degree">Some college, no degree</option>
                <option value="Associate's degree">Associate's degree</option>
                <option value="Bachelor's degree">Bachelor's degree</option>
                <option value="Master's degree">Master's degree</option>
                <option value="Doctoral degree or higher">Doctoral degree or higher</option>
              </select>
            </div>
          </div>
        </div>
      </div>



      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Current Address</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            {/* Full Address - Full Width */}
            <div className="col-12">
              <label className="form-label">Street Address</label>
              <input type="text" className="form-control" placeholder="Enter full street address" value={guest?.address || ''} onChange={(e) => setGuest({ ...guest, address: e.target.value })} />
            </div>

            {/* City and State */}
            <div className="col-md-6">
              <label className="form-label">City</label>
              <input type="text" className="form-control" placeholder="Enter city" value={guest?.city || ''} onChange={(e) => setGuest({ ...guest, city: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">State</label>
              <select className="form-select" value={guest?.state || ''} onChange={(e) => setGuest({ ...guest, state: e.target.value })} >
                <option value="">Select state</option>
                {states.map((state, index) => (
                  <option key={index} value={state.state_id}>{state.state_name} {state.state_abbreviation}</option>
                ))}
              </select>
            </div>

            {/* ZIP and Phone */}
            <div className="col-md-6">
              <label className="form-label">ZIP Code</label>
              <input type="text" className="form-control" placeholder="Enter ZIP code" value={guest?.zip || ''} onChange={(e) => setGuest({ ...guest, zip: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Phone</label>
              <input type="tel" className="form-control" placeholder="123-456-7890" maxLength={14} value={guest?.address_phone || ''} onChange={(e) => setGuest({ ...guest, address_phone: formatUSPhone(e.target.value) })} />
            </div>
          </div>
        </div>
      </div>




      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Emergency Contact</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            {/* Contact Name - Full Width */}
            <div className="col-12">
              <label className="form-label">Contact Name</label>
              <input type="text" className="form-control" placeholder="Enter contact's full name" value={guest?.emergency_contact_name || ''} onChange={(e) => setGuest({ ...guest, emergency_contact_name: e.target.value })} />
            </div>

            {/* Phone and Relationship */}
            <div className="col-md-6">
              <label className="form-label">Phone</label>
              <input type="tel" className="form-control" placeholder="123-456-7890" maxLength={14} value={guest?.emergency_contact_phone || ''} onChange={(e) => setGuest({ ...guest, emergency_contact_phone: formatUSPhone(e.target.value) })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Relationship</label>
              <input type="text" className="form-control" placeholder="e.g., Mother, Friend" value={guest?.emergency_contact_relationship || ''} onChange={(e) => setGuest({ ...guest, emergency_contact_relationship: e.target.value })} />
            </div>
          </div>
        </div>
      </div>






      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Employment Status</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            {/* Employed / Unemployed Radio */}
            <div className="col-12">
              <label className="form-label d-block">Employment Status</label>

              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" name="employment_status" id="unemployed" value="unemployed" checked={guest?.employment_status === 'unemployed'} onChange={(e) => setGuest({ ...guest, employment_status: e.target.value })} />
                <label className="form-check-label" htmlFor="unemployed">Unemployed</label>
              </div>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" name="employment_status" id="employed" value="employed" checked={guest?.employment_status === 'employed'} onChange={(e) => setGuest({ ...guest, employment_status: e.target.value })} />
                <label className="form-check-label" htmlFor="employed">Employed</label>
              </div>
            </div>

            {/* Employer and Position - Only if employed */}
            {guest?.employment_status === 'employed' && (
              <>
                <div className="col-md-6">
                  <label className="form-label">Employer</label>
                  <input type="text" className="form-control" placeholder="Enter employer name" value={guest?.employer || ''} onChange={(e) => setGuest({ ...guest, employer: e.target.value })} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Position</label>
                  <input type="text" className="form-control" placeholder="Enter position" value={guest?.position || ''} onChange={(e) => setGuest({ ...guest, position: e.target.value })} />
                </div>
              </>
            )}

            {/* Source of Income */}
            <div className="col-12">
              <label className="form-label">Source of Income</label>
              <input type="text" className="form-control" placeholder="e.g., Employment, SSI, Disability" value={guest?.income_source || ''} onChange={(e) => setGuest({ ...guest, income_source: e.target.value })} />
            </div>
          </div>
        </div>
      </div>




      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Document Checklist</h5></div>
        <div className="card-body p-4">
          {[
            { key: 'doc_ss_card', label: 'Social Security Card' },
            { key: 'doc_birth_cert', label: 'Birth Certificate' },
            { key: 'doc_photo_id', label: 'Valid Photo ID' },
            { key: 'doc_driver_license',  label: 'Driver License' },
            { key: 'doc_assistance',  label: 'Food Stamps / Assistance' }
          ].map(item => (
            <div className="mb-4" key={item.key}>
              <div className="form-check mb-4">
                <input className="form-check-input" type="checkbox" id={item.key} checked={guest?.documentChecklist?.[item.key]?.checked || false} onChange={(e) => setGuest({
                  ...guest,
                  documentChecklist: {
                    ...guest?.documentChecklist,
                    [item.key]: {
                      ...guest?.documentChecklist?.[item.key],
                      checked: e.target.checked
                    }
                  }
                })} />
                <label className="form-check-label" htmlFor={item.key}>{item.label}</label>
              </div>
              {!guest?.documentChecklist?.[item.key]?.checked && (
                <>
                  <label className="form-label">If no, provide plan;</label>
                  <textarea className="form-control mt-2" placeholder="Provide plan" onChange={(e) => setGuest({
                    ...guest,
                    documentChecklist: {
                      ...guest?.documentChecklist,
                      [item.key]: {
                        ...guest?.documentChecklist?.[item.key],
                        note: e.target.value
                      }
                    }
                  })} >
{guest?.documentChecklist?.[item.key]?.note || ''} 
                    </textarea>

                </>
              )}
            </div>
          ))}
        </div>
      </div>











      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Recovery Information</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            <div className="col-md-12">
              <label className="form-label">Amount of Recovery Clean Time</label>
              <input type="text" className="form-control" placeholder="e.g., 6 months" value={guest?.recovery_clean_time || ''} onChange={(e) => setGuest({ ...guest, recovery_clean_time: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Drug of Choice</label>
              <input type="text" className="form-control" placeholder="e.g., Alcohol, Heroin" value={guest?.recovery_drug_choice || ''} onChange={(e) => setGuest({ ...guest, recovery_drug_choice: e.target.value })} />
            </div>
            <div className="col-md-6">
              <label className="form-label">Date of Last Usage</label>
              <Flatpickr placeholder="Select a date" className="form-control" value={guest?.recovery_last_use || ''} onChange={(date) => setGuest({ ...guest, recovery_last_use: formatDate(date[0]) })} options={{ altInput: true, altFormat: "m/d/Y", dateFormat: "Y-m-d" }} />
            </div>
          </div>
        </div>
      </div>






      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Medical & Mental Health</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">

            {/* Group 1: Medications */}
            <div className="col-12">
              <label className="form-label d-block">Are you currently taking any medications?</label>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" name="on_medications" id="medYes" value="yes" checked={guest?.on_medications === 'yes'} onChange={(e) => setGuest({ ...guest, on_medications: e.target.value })} />
                <label className="form-check-label" htmlFor="medYes">Yes</label>
              </div>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" name="on_medications" id="medNo" value="no" checked={guest?.on_medications === 'no'} onChange={(e) => setGuest({ ...guest, on_medications: e.target.value })} />
                <label className="form-check-label" htmlFor="medNo">No</label>
              </div>
              {guest?.on_medications === 'yes' && (
                <textarea className="form-control mt-3" placeholder="If yes, list all medications here" value={guest?.medications || ''} onChange={(e) => setGuest({ ...guest, medications: e.target.value })} />
              )}
            </div>

            {/* Group 2: suicide_history Thoughts */}
            <div className="col-12">
              <label className="form-label d-block">Have you ever thought about, or attempted suicide?</label>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" name="suicide_history" id="suicideYes" value="yes" checked={guest?.suicide_history === 'yes'} onChange={(e) => setGuest({ ...guest, suicide_history: e.target.value })} />
                <label className="form-check-label" htmlFor="suicideYes">Yes</label>
              </div>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" name="suicide_history" id="suicideNo" value="no" checked={guest?.suicide_history === 'no'} onChange={(e) => setGuest({ ...guest, suicide_history: e.target.value })} />
                <label className="form-check-label" htmlFor="suicideNo">No</label>
              </div>
            </div>

            {/* Group 3: Currently in Treatment */}
            <div className="col-12">
              <label className="form-label d-block">Are you currently attending treatment?</label>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" name="attending_treatment" id="treatmentYes" value="yes" checked={guest?.attending_treatment === 'yes'} onChange={(e) => setGuest({ ...guest, attending_treatment: e.target.value })} />
                <label className="form-check-label" htmlFor="treatmentYes">Yes</label>
              </div>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" name="attending_treatment" id="treatmentNo" value="no" checked={guest?.attending_treatment === 'no'} onChange={(e) => setGuest({ ...guest, attending_treatment: e.target.value, treatment_where: '', counselor_name: '' })} />
                <label className="form-check-label" htmlFor="treatmentNo">No</label>
              </div>
            </div>

            {guest?.attending_treatment === 'yes' && (
              <>
                <div className="col-md-6">
                  <label className="form-label">Where</label>
                  <input type="text" className="form-control" placeholder="Enter treatment location" value={guest?.treatment_where || ''} onChange={(e) => setGuest({ ...guest, treatment_where: e.target.value })} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Counselor Name</label>
                  <input type="text" className="form-control" placeholder="Enter counselor name" value={guest?.counselor_name || ''} onChange={(e) => setGuest({ ...guest, counselor_name: e.target.value })} />
                </div>
              </>
            )}



            {/* Group 4: Currently Attending Therapy */}
            <div className="col-12">
              <label className="form-label d-block">Are you currently attending therapy?</label>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" name="attending_therapy" id="therapyYes" value="yes" checked={guest?.attending_therapy === 'yes'} onChange={(e) => setGuest({ ...guest, attending_therapy: e.target.value })} />
                <label className="form-check-label" htmlFor="therapyYes">Yes</label>
              </div>
              <div className="form-check form-check-inline  mt-3">
                <input className="form-check-input" type="radio" name="attending_therapy" id="therapyNo" value="no" checked={guest?.attending_therapy === 'no'} onChange={(e) => setGuest({ ...guest, attending_therapy: e.target.value, therapy_where: '', therapist_name: '' })} />
                <label className="form-check-label" htmlFor="therapyNo">No</label>
              </div>
            </div>

            {guest?.attending_therapy === 'yes' && (
              <>
                <div className="col-md-6">
                  <label className="form-label">Where</label>
                  <input type="text" className="form-control" placeholder="Enter therapy location" value={guest?.therapy_where || ''} onChange={(e) => setGuest({ ...guest, therapy_where: e.target.value })} />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Therapist's Name</label>
                  <input type="text" className="form-control" placeholder="Enter therapist's name" value={guest?.therapist_name || ''} onChange={(e) => setGuest({ ...guest, therapist_name: e.target.value })} />
                </div>
              </>
            )}



          </div>
        </div>
      </div>






      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Religious Affiliation</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            <div className="col-12">
              <label className="form-label">Do you have any church in your background:</label>
              <textarea rows="5" className="form-control" placeholder="Write your response here" value={guest?.religious_background || ''} onChange={(e) => setGuest({ ...guest, religious_background: e.target.value })} />
            </div>
          </div>
        </div>
      </div>




      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Image Release</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">
            <div className="col-12">
              <label className="form-label d-block">Do you give BBM consent to post pictures or videos on social media or other advertising platforms?</label>
              <div className="form-check form-check-inline mt-3">
                <input className="form-check-input" type="radio" name="image_release" id="imageYes" value="yes" checked={guest?.image_release === 'yes'} onChange={(e) => setGuest({ ...guest, image_release: e.target.value })} />
                <label className="form-check-label" htmlFor="imageYes">Yes</label>
              </div>
              <div className="form-check form-check-inline mt-3">
                <input className="form-check-input" type="radio" name="image_release" id="imageNo" value="no" checked={guest?.image_release === 'no'} onChange={(e) => setGuest({ ...guest, image_release: e.target.value })} />
                <label className="form-check-label" htmlFor="imageNo">No</label>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div className="card shadow mt-4">
        <div className="card-header"><h5 className="mb-0">Free Through Recovery Program or Community Connect</h5></div>
        <div className="card-body p-4">
          <div className="row g-4">

            {/* Enrolled? */}
            <div className="col-12">
              <label className="form-label d-block">Are you enrolled in FTR or CC programming?</label>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" name="ftr_enrolled" id="ftrYes" value="yes" checked={guest?.ftr_enrolled === 'yes'} onChange={(e) => setGuest({ ...guest, ftr_enrolled: e.target.value, ftr_interest: '' })} />
                <label className="form-check-label" htmlFor="ftrYes">Yes</label>
              </div>
              <div className="form-check form-check-inline">
                <input className="form-check-input" type="radio" name="ftr_enrolled" id="ftrNo" value="no" checked={guest?.ftr_enrolled === 'no'} onChange={(e) => setGuest({ ...guest, ftr_enrolled: e.target.value, ftr_provider: '' })} />
                <label className="form-check-label" htmlFor="ftrNo">No</label>
              </div>
            </div>

            {/* If Yes - Show Name & Agency */}
            {guest?.ftr_enrolled === 'yes' && (
              <div className="col-12">
                <textarea className="form-control" placeholder="If yes, Name and Agency of FTR or CC provider" value={guest?.ftr_provider || ''} onChange={(e) => setGuest({ ...guest, ftr_provider: e.target.value })} />
              </div>
            )}

            {/* If No - Ask interest */}
            {guest?.ftr_enrolled === 'no' && (
              <div className="col-12">
                <label className="form-label d-block">If not, are you interested in FTR or CC programming if qualified?</label>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="ftr_interest" id="ftrInterestYes" value="yes" checked={guest?.ftr_interest === 'yes'} onChange={(e) => setGuest({ ...guest, ftr_interest: e.target.value })} />
                  <label className="form-check-label" htmlFor="ftrInterestYes">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="ftr_interest" id="ftrInterestNo" value="no" checked={guest?.ftr_interest === 'no'} onChange={(e) => setGuest({ ...guest, ftr_interest: e.target.value })} />
                  <label className="form-check-label" htmlFor="ftrInterestNo">No</label>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>



      <div className="card shadow mt-4 mb-5">
        <div className="card-body">
          <div className="d-flex flex-wrap gap-3 justify-content-center">


            {/* Save & Next/ Update Next */}
            <button type="button" className="btn btn-lg btn-dark" onClick={handleSaveAndNext} disabled={isDisabled} >{isEdit ? `Update & Next` : 'Save & Next'} </button>


          </div>
        </div>
      </div>


    </div>




  );
};

export default GuestIntakeForm;
